/* eslint-disable */
export default function load(module) {
  switch(module) {
    case '@bingads-webui-campaign-legacy/budget/view/bid-suggestion-popup':
      return import(/* webpackChunkName: "settings-page-dynamic-feature-bid-suggestion" */ '@bingads-webui-campaign-legacy/budget/view/bid-suggestion-popup');
    default:
      return new Promise(null);
  }
}
